import service from "@/utils/request";

/**
 * 根据物料编码和供应商ID/名称查询库存
 * @param {Object} params - 查询参数
 * @param {string} params.materialNo - 物料编码
 * @param {string} params.supplierId - 供应商ID
 * @param {string} params.supplierName - 供应商名称
 * @param {number} params.current - 页码
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
export function queryMaterialStock(params) {
  return service.get("/uic-system/materialstock/page", {
    params: {
      materialNo: params.materialNo,
      supplierId: params.supplierId,
      supplierName: params.supplierName, // 添加供应商名称参数
      current: params.current || 1,
      size: params.size || 20,
    },
  });
}

/**
 * 通过编码查询供应商
 * @param {string} code - 供应商编码
 * @returns {Promise}
 */
export function getSupplierByCode(code) {
  return service.get("/uic-system/supplier/page", {
    params: {
      current: 1,
      size: 20,
      supplierCode: code,
    },
  });
}

/**
 * 检查物料是否存在
 */
export function checkMaterialExists(params) {
  return service.get(
    "/uic-system_hf/materialstockdetail/getStockDetailListByMaterialId",
    {
      params: {
        materialId: params.materialId,
        batchNo: params.batchNo,
        current: 1,
        size: 1,
      },
    },
  );
}

/**
 * 获取物料信息
 */
export function getMaterialByNo(materialNo, supplierId) {
  return service.get("/uic-system_hf/material/page", {
    params: {
      materialNo,
      supplierId: supplierId || "", // 添加供应商ID参数
      current: 1,
      size: 20,
      isCompose: 0,
    },
  });
}

/**
 * 查询库存库位详情
 * @param {Object} params - 查询参数
 * @param {string} params.materialNo - 物料编码
 * @param {string} params.supplierId - 供应商ID
 * @param {number} params.current - 页码
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
export function getStockWareDetail(params) {
  return service.get("/uic-system/hf_materialstock/page", {
    params: {
      materialNo: params.materialNo,
      supplierId: params.supplierId,
      current: params.current || 1,
      size: params.size || 20,
    },
  });
}
